import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import Analytics from './../../analytics';
import {getCurrentLayout} from '../appLayout';
import {setQtActiveCategory, changeActivePartRelatedItemIndex} from "../../actions/actionFunctions";
import QtCategoryName from "../visComponents/qtCategoryName";
import {getDashboardThemeIcon} from "../bvComponent/core/assets";

class SelectionMainSelectCategory extends Component {

  static propTypes = {
    type: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
    };
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleWrapperBlur);
  }

  handleCategoryClick = (qtCategory) => {
    if (qtCategory.name !== this.props.qtActiveCategory) {
      Analytics.sendClickEvent('footer-category-change');
      this.props.setQtActiveCategory(qtCategory.name);
      this.props.changeActivePartRelatedItemIndex(0);
      this.handleToggleDropdown();
    }
  };

  handleToggleDropdown = () => {
    this.setState({
      toggle: !this.state.toggle
    }, () => {
      setTimeout(() => {
        this.state.toggle
          ? window.addEventListener('click', this.handleWrapperBlur)
          : window.removeEventListener('click', this.handleWrapperBlur)
      }, 0)
    })
  };

  handleWrapperBlur = (e) => {
    if (this.state.toggle && !e.target.closest('.ui-select2__dropdown-list-item')
      && !e.target.closest('.ui-select2__dropdown-back') && !e.target.closest('.ui-select2__dropdown')) {
      this.handleToggleDropdown();
    }
  };

  getImage = (bgImageUrl) => {
    if (bgImageUrl && (this.props.activeTheme === "caes" || this.props.activeTheme === "moderno")) {
      return getDashboardThemeIcon(bgImageUrl, this.props.activeTheme)
    }
    return bgImageUrl
  };

  render() {
    const layout = getCurrentLayout();
    const baseClass = this.props.type === 1 ? "ui-select" : "ui-select"+this.props.type;
    const dropDownStyles = this.state.toggle ? { height:window.innerHeight - 60 } : {};
    if (this.state.toggle) {
      dropDownStyles.height = (this.props.windowWidth > 991 && window.innerHeight > 320) ? 320 : window.innerHeight - 60
    }
    const withIcon = this.props.type === 2;

    return (
      <div className={baseClass + (this.state.toggle ? ` ${baseClass}--opened` : "")}>
        <div className={baseClass+"__input"} onClick={this.handleToggleDropdown}>
          <span className={baseClass+"__input-label"}>
            <FormattedMessage id="quotingTool.footer.selectDropdownSortBy"/>
          </span>
          <span className={baseClass+"__input-value"}>
            <QtCategoryName qtCategoryName={this.props.qtActiveCategory}/>
          </span>
        </div>
        <div className={baseClass+"__dropdown"} style={dropDownStyles}>
          <ul className={baseClass+"__dropdown-list"}>
            {layout.qtCategories ? layout.qtCategories.map((qtCategory, index) => {
              let bgImageUrl = this.getImage(qtCategory.bgImageUrl);
              const isActive = qtCategory.name === this.props.qtActiveCategory;
              // if (isActive) {
              //   bgImageUrl = qtCategory.bgImageUrl.split(".svg")[0] + "-white.svg"
              // }
              return (
                <li key={"dropdown"+index}
                    data-index={index}
                    onClick={() => this.handleCategoryClick(qtCategory)}
                    style={{
                      backgroundImage: `url(${bgImageUrl})`,
                      backgroundSize: "60px",
                      backgroundPosition: "left -3px center"
                    }}
                    className={baseClass+"__dropdown-list-item"
                    + (isActive ? ` ${baseClass}__dropdown-list-item--active icon--white` : "")
                    + (withIcon ? ` icon--active--white icon--${qtCategory.name.toLowerCase().replace(/ /g,"_")}` : "")}>
                  <QtCategoryName qtCategoryName={qtCategory.name}/>
                </li>
              )
            }): null}
          </ul>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const {windowWidth, activeTheme} = store.serverState;
  return {
    windowWidth,
    activeTheme,
    qtActiveCategory: store.qtState.qtActiveCategory,
  };
};

const mapDispatchToProps = {
  setQtActiveCategory,
  changeActivePartRelatedItemIndex
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectionMainSelectCategory)
